import React, { useRef, useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const CopyToClipBoard = () => {
    const inputField1Ref = useRef(null);
  const inputField2Ref = useRef(null);

  const [textToCopy1, setTextToCopy1] = useState('Hello, world!');
  const [textToCopy2, setTextToCopy2] = useState(
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit...'
  );
  const [isCopied1, setIsCopied1] = useState(false);
  const [isCopied2, setIsCopied2] = useState(false);

  const handleCopyClick = async (inputRef : any, setIsCopied : any, setTextToCopy? : any) => {
    try {
      const textToCopy = inputRef.current.value;
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
      setTextToCopy('');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Clipboard" pageType="Components" />
      
    <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="card">
          <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
            Copy from input
          </h2>
          <div className="flex flex-col gap-4">
            <input
              type="text"
              ref={inputField1Ref}
              className="form-input"
              value={textToCopy1}
              onChange={(e) => setTextToCopy1(e.target.value)}
            />
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() =>  handleCopyClick(inputField1Ref, setIsCopied1)}
                className={`btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85] ${
                  isCopied1 ? 'bg-green-500' : ''
                }`}
              >
                Copy
              </button>
              <button
                onClick={() =>  handleCopyClick(inputField1Ref, setIsCopied1, setTextToCopy1)}
                className={`btn bg-light border border-light rounded-md text-black transition-all duration-300 hover:bg-light/[0.85] hover:border-light/[0.85] ${
                  isCopied1 ? 'bg-green-500' : ''
                }`}
              >
                Cut
              </button>
            </div>
          </div>
        </div>
        <div className="card">
          <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
            Copy from Textarea
          </h2>
          <div className="flex flex-col gap-4">
            <textarea
              ref={inputField2Ref}
              className="h-auto form-textarea"
              rows={3}
              value={textToCopy2}
              onChange={(e) => setTextToCopy2(e.target.value)}
            ></textarea>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => handleCopyClick(inputField2Ref, setIsCopied2)
                }
                className={`btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85] ${
                  isCopied2 ? 'bg-green-500' : ''
                }`}
              >
                Copy
              </button>
              <button
                onClick={() => handleCopyClick(inputField2Ref, setIsCopied2, setTextToCopy2)
                }
                className={`btn bg-light border border-light rounded-md text-black transition-all duration-300 hover:bg-light/[0.85] hover:border-light/[0.85] ${
                  isCopied2 ? 'bg-green-500' : ''
                }`}
              >
                Cut
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </React.Fragment>
  );
};

export default CopyToClipBoard;
